import React from "react";
import { Icon } from "@chakra-ui/react";

export const ArrowBackIcon = ({ ...props }) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14 7L9 12L14 17V7Z" fill="#1A1A1A" />
    </Icon>
  );
};
